/*
 * This file is part of the Det Norske Teatret Nettside 2019 application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import PropTypes from 'prop-types';
import './Expand.scss';

/**
 * This is the Expand component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 *
 * @return {JSX}
 */
function Expand({ title, open }) {
  function renderSvg() {
    if (open) {
      return (
        <svg
          width="17"
          height="17"
          viewBox="0 0 17 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>{title}</title>
          <path
            d="M16.75 10C16.8167 10 16.875 9.89167 16.925 9.675C16.975 9.45833 17 9.23333 17 9C17 8.76667 16.975 8.54167 16.925 8.325C16.875 8.10833 16.8167 8 16.75 8H0.2C0.133333 8 0.0833333 8.1 0.05 8.3C0.0166667 8.5 0 8.71667 0 8.95C0 9.21667 0.025 9.45833 0.075 9.675C0.125 9.89167 0.183333 10 0.25 10H16.75Z"
            fill="black"
          />
        </svg>
      );
    }

    return (
      <svg
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>{title}</title>
        <path
          d="M8.35 16.95C8.61667 16.95 8.875 16.925 9.125 16.875C9.375 16.825 9.5 16.7667 9.5 16.7V9.45H16.75C16.8167 9.45 16.875 9.34167 16.925 9.125C16.975 8.90833 17 8.68333 17 8.45C17 8.21667 16.975 8 16.925 7.8C16.875 7.6 16.8167 7.5 16.75 7.5H9.5V0.25C9.5 0.183333 9.39167 0.125 9.175 0.075C8.95833 0.025 8.73333 0 8.5 0C8.26667 0 8.04167 0.025 7.825 0.075C7.60833 0.125 7.5 0.183333 7.5 0.25V7.5H0.2C0.166667 7.5 0.125 7.59167 0.075 7.775C0.025 7.95833 0 8.16667 0 8.4C0 8.66667 0.025 8.90833 0.075 9.125C0.125 9.34167 0.183333 9.45 0.25 9.45H7.5V16.8C7.5 16.9 7.78333 16.95 8.35 16.95Z"
          fill="black"
        />
      </svg>
    );
  }

  return (
    <span className="svg svg-square svg-expand">
      <span>{renderSvg()}</span>
    </span>
  );
}

/**
 * Declare expected prop types.
 *
 * @type {Object}
 */
Expand.propTypes = {
  title: PropTypes.string.isRequired,
  open: PropTypes.bool,
};

/**
 * Declare defaults for non-required props.
 *
 * @type {Object}
 */
Expand.defaultProps = {
  title: 'Expand',
  open: false,
};

export default Expand;
